import $ from 'jquery';
import 'svg4everybody';

import header from './blocks/header';
import carousel from './blocks/carousel';
import modal from './blocks/modal';
import card from './blocks/card-horizontal.js';

svg4everybody();

$('html').addClass('js').removeClass('no-js');

$(function() {
    header.init();
    carousel.init();
    modal.init();
    card.init();
});



// WEBPACK FOOTER //
// ./src/scripts/app.js